import { ProjectsTopbar } from './ProjectsTopbar';
import { ProjectMonitoringLayout } from './[Project]/Monitoring/Monitoring.layout';
import { ProjectLayout } from './[Project]/[Project].layout';
import { breadcrumbTranslation } from 'components/layout/Breadcrumb/utils';
import { CreateReportBreadcrumb } from 'components/layout/DynamicBreadcrumbs/CreateReportBreadcrumb';
import { ProjectBreadcrumb } from 'components/layout/DynamicBreadcrumbs/ProjectBreadcrumb';

export const projectsOverviewRoutes = [
  {
    path: 'projects',
    breadcrumb: breadcrumbTranslation('projects'),
    element: <ProjectsTopbar />,
    children: [
      {
        index: true,
        lazy: () => import('pages/Projects/CardView'),
      },
      {
        path: 'overview',
        breadcrumb: breadcrumbTranslation('projects-overview'),
        lazy: () => import('pages/Projects/Overview'),
      },
      {
        path: 'map',
        breadcrumb: breadcrumbTranslation('projects-map'),
        lazy: () => import('pages/Projects/MapView'),
      },
    ],
  },
];

export const newProjectRoute = {
  path: 'projects',
  breadcrumb: breadcrumbTranslation('projects'),
  children: [
    {
      path: 'new',
      breadcrumb: breadcrumbTranslation('projects-new'),
      lazy: () => import('pages/Projects/New'),
    },
  ],
};

export const projectsRoutes = [
  {
    path: 'projects',
    breadcrumb: breadcrumbTranslation('projects'),
    children: [
      {
        path: ':projectSlug',
        element: <ProjectLayout />,
        children: [
          {
            index: true,
            breadcrumb: ProjectBreadcrumb,
            lazy: () => import('pages/Projects/[Project]'),
          },
          {
            path: 'administration',
            breadcrumb: breadcrumbTranslation('projects-administration'),
            lazy: () => import('pages/Projects/[Project]/Administration'),
          },
          {
            path: 'setups',
            breadcrumb: breadcrumbTranslation('projects-setups'),
            lazy: () => import('pages/Projects/[Project]/Setups'),
          },
          {
            path: 'analytics',
            breadcrumb: null,
            children: [
              {
                path: 'reports',
                breadcrumb: breadcrumbTranslation('projects-analytics-reports'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Reports'),
              },
              {
                path: 'reports/new-report',
                breadcrumb: breadcrumbTranslation('projects-analytics-new-report'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Reports/NewReport'),
              },
              {
                path: 'reports/new-report/:microgridId',
                breadcrumb: CreateReportBreadcrumb,
                lazy: () => import('pages/Projects/[Project]/Analytics/Reports/NewReport/[Microgrid]'),
              },
              {
                path: 'summary',
                breadcrumb: breadcrumbTranslation('projects-analytics-summary'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Summary'),
              },
              {
                path: 'assets',
                breadcrumb: breadcrumbTranslation('projects-analytics-assets'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Assets'),
              },
            ],
          },
          {
            path: 'monitoring',
            breadcrumb: null,
            element: <ProjectMonitoringLayout />,
            children: [
              {
                path: ':unitExternalIdentifier',
                breadcrumb: null,
                children: [
                  {
                    path: 'asset',
                    breadcrumb: breadcrumbTranslation('projects-monitoring-assets'),
                    lazy: () => import('pages/Assets/[Asset]'),
                  },
                  {
                    path: 'basic-graphs',
                    breadcrumb: breadcrumbTranslation('projects-monitoring-basic-graphs'),
                    lazy: () => import('pages/Assets/[Asset]/BasicGraphs'),
                  },
                  {
                    path: 'advanced-graphs',
                    breadcrumb: breadcrumbTranslation('projects-monitoring-advanced-graphs'),
                    lazy: () => import('pages/Assets/[Asset]/AdvancedGraphs'),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
